export const ChevronSVGData = `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group">
        <path id="Vector" d="M14.5 5L8.5 11L2.5 5" stroke="inherit" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
    </g>
</svg>
`;
